import { stageGeneratorParent } from "../stageGeneratorParent.js"
import { primaryStageGenerator } from "../stage/state"

export class primaryAppStageGenerator extends stageGeneratorParent {
  constructor(opt) {
    super()
    this.container_id = 0
    this.width = 375
    this.height = 667
    this.isActive = false
    this.children = []
    this.options = {
      inDocument: "none",
      isFixed: false,
      background: [
        {
          type: "color",
          label: "颜色",
          isThemeColor: false,
          color: "#fff"
        }
      ],
      opacity: 100
    }
    this.objDiff(this, opt)
  }
}
export class primaryappStageheaderGenerator extends stageGeneratorParent {
  constructor(opt) {
    super()
    this.container_id = 0
    this.width = 375
    this.height = 100
    this.isActive = false
    this.children = []
    this.options = {
      inDocument: "header",
      isFixed: false,
      background: [
        {
          type: "color",
          label: "颜色",
          isThemeColor: false,
          color: "#000"
        }
      ],
      opacity: 100
    }
    this.objDiff(this, opt)
  }
}
export class primaryappStagefooterGenerator extends stageGeneratorParent {
  constructor(opt) {
    super()
    this.container_id = 0
    this.width = 375
    this.height = 100
    this.isActive = false
    this.children = []
    this.options = {
      inDocument: "footer",
      isFixed: false,
      background: [
        {
          type: "color",
          label: "颜色",
          isThemeColor: false,
          color: "#000"
        }
      ],
      opacity: 100
    }
    this.objDiff(this, opt)
  }
}

export class primaryappStagePageLayoutGenerator extends stageGeneratorParent {
  constructor(opt, specialOpt) {
    super()
    switch (opt) {
      case 1:
        ;(this.options = {
          bg: [],
          padding: [40, 0, 40, 0],
          opacity: 100,
          height: 200,
          paddingTypeFlag: 2,
          isFullPage: false,
          inDocument: "none",
          isFixed: false,
          isShow: true
        }),
          (this.id = 1),
          (this.layout = {
            rows: [
              {
                id: 0,
                options: {
                  padding: [0, 0, 0, 0],
                  bg: [],
                  height: 200,
                  width: "100%",
                  borderTypeFlag: 1,
                  borderRadius: [0, 0, 0, 0],
                  borderWidth: 0,
                  borderStyle: "solid",
                  borderColor: "rgba(0,0,0,0)",
                  borderIsThemeColor: false
                },
                rectIds: [],
                layout: {
                  rows: [],
                  cols: []
                }
              }
            ]
          })
        break
      case 2:
        ;(this.options = {
          bg: [],
          padding: [40, 0, 40, 0],
          opacity: 100,
          height: 200,
          paddingTypeFlag: 2,
          isFullPage: false,
          inDocument: "none",
          isFixed: false,
          isShow: true
        }),
          (this.id = 1),
          (this.layout = {
            rows: [
              {
                id: 0,
                options: {
                  padding: [0, 0, 0, 0],
                  bg: [],
                  height: 200,
                  width: "100%",
                  borderTypeFlag: 1,
                  borderRadius: [0, 0, 0, 0],
                  borderWidth: 0,
                  borderStyle: "solid",
                  borderColor: "rgba(0,0,0,0)",
                  borderIsThemeColor: false
                },
                rectIds: [],
                layout: {
                  rows: [],
                  cols: [
                    {
                      id: 0,
                      options: {
                        padding: [0, 0, 0, 0],
                        bg: [],
                        height: 200,
                        width: "50%",
                        borderTypeFlag: 1,
                        borderRadius: [0, 0, 0, 0],
                        borderWidth: 0,
                        borderStyle: "solid",
                        borderColor: "rgba(0,0,0,0)",
                        borderIsThemeColor: false
                      },
                      rectIds: [],
                      layout: {
                        rows: [],
                        cols: []
                      }
                    },
                    {
                      id: 1,
                      options: {
                        padding: [0, 0, 0, 0],
                        bg: [],
                        height: 200,
                        width: "50%",
                        borderTypeFlag: 1,
                        borderRadius: [0, 0, 0, 0],
                        borderWidth: 0,
                        borderStyle: "solid",
                        borderColor: "rgba(0,0,0,0)",
                        borderIsThemeColor: false
                      },
                      rectIds: [],
                      layout: {
                        rows: [],
                        cols: []
                      }
                    }
                  ]
                }
              }
            ]
          })
        break
      case 3:
        ;(this.id = 1),
          (this.options = {
            bg: [],
            padding: [40, 0, 40, 0],
            opacity: 100,
            height: 200,
            paddingTypeFlag: 2,
            isFullPage: false,
            inDocument: "none",
            isFixed: false,
            isShow: true
          }),
          (this.layout = {
            rows: [
              {
                id: 0,
                options: {
                  padding: [0, 0, 0, 0],
                  bg: [],
                  height: 300,
                  width: "100%",
                  borderTypeFlag: 1,
                  borderRadius: [0, 0, 0, 0],
                  borderWidth: 0,
                  borderStyle: "solid",
                  borderColor: "rgba(0,0,0,0)",
                  borderIsThemeColor: false
                },
                rectIds: [],
                layout: {
                  rows: [
                    {
                      id: 0,
                      options: {
                        padding: [0, 0, 0, 0],
                        bg: [],
                        height: 100,
                        width: "100%",
                        borderTypeFlag: 1,
                        borderRadius: [0, 0, 0, 0],
                        borderWidth: 0,
                        borderStyle: "solid",
                        borderColor: "rgba(0,0,0,0)",
                        borderIsThemeColor: false
                      },
                      rectIds: [],
                      layout: {
                        rows: [],
                        cols: []
                      }
                    },
                    {
                      id: 1,
                      options: {
                        padding: [0, 0, 0, 0],
                        bg: [],
                        height: 200,
                        width: "100%",
                        borderTypeFlag: 1,
                        borderRadius: [0, 0, 0, 0],
                        borderWidth: 0,
                        borderStyle: "solid",
                        borderColor: "rgba(0,0,0,0)",
                        borderIsThemeColor: false
                      },
                      rectIds: [],
                      layout: {
                        rows: [],
                        cols: [
                          {
                            id: 0,
                            options: {
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 200,
                              width: "50%",
                              borderTypeFlag: 1,
                              borderRadius: [0, 0, 0, 0],
                              borderWidth: 0,
                              borderStyle: "solid",
                              borderColor: "rgba(0,0,0,0)",
                              borderIsThemeColor: false
                            },
                            rectIds: [],
                            layout: {
                              rows: [],
                              cols: []
                            }
                          },
                          {
                            id: 1,
                            options: {
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 200,
                              width: "50%",
                              borderTypeFlag: 1,
                              borderRadius: [0, 0, 0, 0],
                              borderWidth: 0,
                              borderStyle: "solid",
                              borderColor: "rgba(0,0,0,0)",
                              borderIsThemeColor: false
                            },
                            rectIds: [],
                            layout: {
                              rows: [],
                              cols: []
                            }
                          }
                        ]
                      }
                    }
                  ],
                  cols: []
                }
              }
            ]
          })
        break
      case 4:
        ;(this.id = 1),
          (this.options = {
            bg: [],
            padding: [40, 0, 40, 0],
            opacity: 100,
            height: 400,
            paddingTypeFlag: 2,
            isFullPage: false,
            inDocument: "none",
            isFixed: false,
            isShow: true
          }),
          (this.layout = {
            rows: [
              {
                id: 0,
                options: {
                  padding: [0, 0, 0, 0],
                  bg: [],
                  height: 400,
                  width: "100%",
                  borderTypeFlag: 1,
                  borderRadius: [0, 0, 0, 0],
                  borderWidth: 0,
                  borderStyle: "solid",
                  borderColor: "rgba(0,0,0,0)",
                  borderIsThemeColor: false
                },
                rectIds: [],
                layout: {
                  rows: [
                    {
                      id: 0,
                      options: {
                        padding: [0, 0, 0, 0],
                        bg: [],
                        height: 200,
                        width: "100%",
                        borderTypeFlag: 1,
                        borderRadius: [0, 0, 0, 0],
                        borderWidth: 0,
                        borderStyle: "solid",
                        borderColor: "rgba(0,0,0,0)",
                        borderIsThemeColor: false
                      },
                      rectIds: [],
                      layout: {
                        rows: [],
                        cols: [
                          {
                            id: 0,
                            options: {
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 200,
                              width: "50%",
                              borderTypeFlag: 1,
                              borderRadius: [0, 0, 0, 0],
                              borderWidth: 0,
                              borderStyle: "solid",
                              borderColor: "rgba(0,0,0,0)",
                              borderIsThemeColor: false
                            },
                            rectIds: [],
                            layout: {
                              rows: [],
                              cols: []
                            }
                          },
                          {
                            id: 1,
                            options: {
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 200,
                              width: "50%",
                              borderTypeFlag: 1,
                              borderRadius: [0, 0, 0, 0],
                              borderWidth: 0,
                              borderStyle: "solid",
                              borderColor: "rgba(0,0,0,0)",
                              borderIsThemeColor: false
                            },
                            rectIds: [],
                            layout: {
                              rows: [],
                              cols: []
                            }
                          }
                        ]
                      }
                    },
                    {
                      id: 1,
                      options: {
                        padding: [0, 0, 0, 0],
                        bg: [],
                        height: 200,
                        width: "100%",
                        borderTypeFlag: 1,
                        borderRadius: [0, 0, 0, 0],
                        borderWidth: 0,
                        borderStyle: "solid",
                        borderColor: "rgba(0,0,0,0)",
                        borderIsThemeColor: false
                      },
                      rectIds: [],
                      layout: {
                        rows: [],
                        cols: [
                          {
                            id: 0,
                            options: {
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 200,
                              width: "50%",
                              borderTypeFlag: 1,
                              borderRadius: [0, 0, 0, 0],
                              borderWidth: 0,
                              borderStyle: "solid",
                              borderColor: "rgba(0,0,0,0)",
                              borderIsThemeColor: false
                            },
                            rectIds: [],
                            layout: {
                              rows: [],
                              cols: []
                            }
                          },
                          {
                            id: 1,
                            options: {
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 200,
                              width: "50%",
                              borderTypeFlag: 1,
                              borderRadius: [0, 0, 0, 0],
                              borderWidth: 0,
                              borderStyle: "solid",
                              borderColor: "rgba(0,0,0,0)",
                              borderIsThemeColor: false
                            },
                            rectIds: [],
                            layout: {
                              rows: [],
                              cols: []
                            }
                          }
                        ]
                      }
                    }
                  ],
                  cols: []
                }
              }
            ]
          })
        break
      case 5:
        ;(this.id = 1),
          (this.options = {
            bg: [],
            padding: [40, 0, 40, 0],
            opacity: 100,
            height: 400,
            paddingTypeFlag: 2,
            isFullPage: false,
            inDocument: "none",
            isFixed: false,
            isShow: true
          }),
          (this.layout = {
            rows: [
              {
                id: 0,
                options: {
                  padding: [0, 0, 0, 0],
                  bg: [],
                  height: 400,
                  width: "100%",
                  borderTypeFlag: 1,
                  borderRadius: [0, 0, 0, 0],
                  borderWidth: 0,
                  borderStyle: "solid",
                  borderColor: "rgba(0,0,0,0)",
                  borderIsThemeColor: false
                },
                rectIds: [],
                layout: {
                  rows: [
                    {
                      id: 0,
                      options: {
                        padding: [0, 0, 0, 0],
                        bg: [],
                        height: 100,
                        width: "100%",
                        borderTypeFlag: 1,
                        borderRadius: [0, 0, 0, 0],
                        borderWidth: 0,
                        borderStyle: "solid",
                        borderColor: "rgba(0,0,0,0)",
                        borderIsThemeColor: false
                      },
                      rectIds: [],
                      layout: {
                        rows: [],
                        cols: [
                          {
                            id: 0,
                            options: {
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 100,
                              width: "50%",
                              borderTypeFlag: 1,
                              borderRadius: [0, 0, 0, 0],
                              borderWidth: 0,
                              borderStyle: "solid",
                              borderColor: "rgba(0,0,0,0)",
                              borderIsThemeColor: false
                            },
                            rectIds: [],
                            layout: {
                              rows: [],
                              cols: []
                            }
                          },
                          {
                            id: 1,
                            options: {
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 100,
                              width: "50%",
                              borderTypeFlag: 1,
                              borderRadius: [0, 0, 0, 0],
                              borderWidth: 0,
                              borderStyle: "solid",
                              borderColor: "rgba(0,0,0,0)",
                              borderIsThemeColor: false
                            },
                            rectIds: [],
                            layout: {
                              rows: [],
                              cols: []
                            }
                          }
                        ]
                      }
                    },
                    {
                      id: 1,
                      options: {
                        padding: [0, 0, 0, 0],
                        bg: [],
                        height: 300,
                        width: "100%",
                        borderTypeFlag: 1,
                        borderRadius: [0, 0, 0, 0],
                        borderWidth: 0,
                        borderStyle: "solid",
                        borderColor: "rgba(0,0,0,0)",
                        borderIsThemeColor: false
                      },
                      rectIds: [],
                      layout: {
                        rows: [],
                        cols: [
                          {
                            id: 0,
                            options: {
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 300,
                              width: "33%",
                              borderTypeFlag: 1,
                              borderRadius: [0, 0, 0, 0],
                              borderWidth: 0,
                              borderStyle: "solid",
                              borderColor: "rgba(0,0,0,0)",
                              borderIsThemeColor: false
                            },
                            rectIds: [],
                            layout: {
                              rows: [],
                              cols: []
                            }
                          },
                          {
                            id: 1,
                            options: {
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 300,
                              width: "34%",
                              borderTypeFlag: 1,
                              borderRadius: [0, 0, 0, 0],
                              borderWidth: 0,
                              borderStyle: "solid",
                              borderColor: "rgba(0,0,0,0)",
                              borderIsThemeColor: false
                            },
                            rectIds: [],
                            layout: {
                              rows: [],
                              cols: []
                            }
                          },
                          {
                            id: 2,
                            options: {
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 300,
                              width: "33%",
                              borderTypeFlag: 1,
                              borderRadius: [0, 0, 0, 0],
                              borderWidth: 0,
                              borderStyle: "solid",
                              borderColor: "rgba(0,0,0,0)",
                              borderIsThemeColor: false
                            },
                            rectIds: [],
                            layout: {
                              rows: [],
                              cols: []
                            }
                          }
                        ]
                      }
                    }
                  ],
                  cols: []
                }
              }
            ]
          })
        break
      case 6:
        ;(this.id = 1),
          (this.options = {
            bg: [],
            padding: [40, 0, 40, 0],
            opacity: 100,
            height: 400,
            paddingTypeFlag: 2,
            isFullPage: false,
            inDocument: "none",
            isFixed: false,
            isShow: true
          }),
          (this.layout = {
            rows: [
              {
                id: 0,
                options: {
                  padding: [0, 0, 0, 0],
                  bg: [],
                  height: 300,
                  width: "100%",
                  borderTypeFlag: 1,
                  borderRadius: [0, 0, 0, 0],
                  borderWidth: 0,
                  borderStyle: "solid",
                  borderColor: "rgba(0,0,0,0)",
                  borderIsThemeColor: false
                },
                rectIds: [],
                layout: {
                  rows: [
                    {
                      id: 0,
                      options: {
                        padding: [0, 0, 0, 0],
                        bg: [],
                        height: 100,
                        width: "100%",
                        borderTypeFlag: 1,
                        borderRadius: [0, 0, 0, 0],
                        borderWidth: 0,
                        borderStyle: "solid",
                        borderColor: "rgba(0,0,0,0)",
                        borderIsThemeColor: false
                      },
                      rectIds: [],
                      layout: {
                        rows: [],
                        cols: []
                      }
                    },
                    {
                      id: 1,
                      options: {
                        padding: [0, 0, 0, 0],
                        bg: [],
                        height: 100,
                        width: "100%",
                        borderTypeFlag: 1,
                        borderRadius: [0, 0, 0, 0],
                        borderWidth: 0,
                        borderStyle: "solid",
                        borderColor: "rgba(0,0,0,0)",
                        borderIsThemeColor: false
                      },
                      rectIds: [],
                      layout: {
                        rows: [],
                        cols: [
                          {
                            id: 0,
                            options: {
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 100,
                              width: "33%",
                              borderTypeFlag: 1,
                              borderRadius: [0, 0, 0, 0],
                              borderWidth: 0,
                              borderStyle: "solid",
                              borderColor: "rgba(0,0,0,0)",
                              borderIsThemeColor: false
                            },
                            rectIds: [],
                            layout: {
                              rows: [],
                              cols: []
                            }
                          },
                          {
                            id: 1,
                            options: {
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 100,
                              width: "34%",
                              borderTypeFlag: 1,
                              borderRadius: [0, 0, 0, 0],
                              borderWidth: 0,
                              borderStyle: "solid",
                              borderColor: "rgba(0,0,0,0)",
                              borderIsThemeColor: false
                            },
                            rectIds: [],
                            layout: {
                              rows: [],
                              cols: []
                            }
                          },
                          {
                            id: 2,
                            options: {
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 100,
                              width: "33%",
                              borderTypeFlag: 1,
                              borderRadius: [0, 0, 0, 0],
                              borderWidth: 0,
                              borderStyle: "solid",
                              borderColor: "rgba(0,0,0,0)",
                              borderIsThemeColor: false
                            },
                            rectIds: [],
                            layout: {
                              rows: [],
                              cols: []
                            }
                          }
                        ]
                      }
                    },
                    {
                      id: 2,
                      options: {
                        padding: [0, 0, 0, 0],
                        bg: [],
                        height: 100,
                        width: "100%",
                        borderTypeFlag: 1,
                        borderRadius: [0, 0, 0, 0],
                        borderWidth: 0,
                        borderStyle: "solid",
                        borderColor: "rgba(0,0,0,0)",
                        borderIsThemeColor: false
                      },
                      rectIds: [],
                      layout: {
                        rows: [],
                        cols: []
                      }
                    }
                  ],
                  cols: []
                }
              }
            ]
          })
        break
      case 7:
        ;(this.id = 1),
          (this.options = {
            bg: [],
            padding: [40, 0, 40, 0],
            opacity: 100,
            height: 400,
            paddingTypeFlag: 2,
            isFullPage: false,
            inDocument: "none",
            isFixed: false,
            isShow: true,
            isShowTabs: true //横向标签通栏标志
          }),
          (this.layout = {
            rows: [
              {
                id: 0,
                options: {
                  padding: [0, 0, 0, 0],
                  bg: [],
                  height: 400,
                  width: "100%",
                  borderTypeFlag: 1,
                  borderRadius: [0, 0, 0, 0],
                  borderWidth: 0,
                  borderStyle: "solid",
                  borderColor: "rgba(0,0,0,0)",
                  borderIsThemeColor: false
                },
                rectIds: [],
                layout: {
                  rows: [
                    {
                      id: 0,
                      options: {
                        padding: [0, 0, 0, 0],
                        bg: [],
                        height: 100,
                        width: "100%",
                        borderTypeFlag: 1,
                        borderRadius: [0, 0, 0, 0],
                        borderWidth: 0,
                        borderStyle: "solid",
                        borderColor: "rgba(0,0,0,0)",
                        borderIsThemeColor: false,
                        tabRow: true //横向标签行标志 用于判断是否显示添加行
                      },
                      rectIds: [],
                      layout: {
                        rows: [],
                        cols: []
                      }
                    },
                    {
                      id: 1,
                      options: {
                        padding: [0, 0, 0, 0],
                        bg: [],
                        height: 300,
                        width: "100%",
                        borderTypeFlag: 1,
                        borderRadius: [0, 0, 0, 0],
                        borderWidth: 0,
                        borderStyle: "solid",
                        borderColor: "rgba(0,0,0,0)",
                        borderIsThemeColor: false
                      },
                      rectIds: [],
                      layout: {
                        rows: [
                          {
                            id: 0,
                            options: {
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 300,
                              width: "100%",
                              borderTypeFlag: 1,
                              borderRadius: [0, 0, 0, 0],
                              borderWidth: 0,
                              borderStyle: "solid",
                              borderColor: "rgba(0,0,0,0)",
                              borderIsThemeColor: false,
                              tabRow: true
                            },
                            rectIds: [],
                            layout: {
                              rows: [],
                              cols: []
                            }
                          },
                          {
                            id: 1,
                            options: {
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 300,
                              width: "100%",
                              borderTypeFlag: 1,
                              borderRadius: [0, 0, 0, 0],
                              borderWidth: 0,
                              borderStyle: "solid",
                              borderColor: "rgba(0,0,0,0)",
                              borderIsThemeColor: false,
                              tabRow: true
                            },
                            rectIds: [],
                            layout: {
                              rows: [],
                              cols: []
                            }
                          },
                          {
                            id: 2,
                            options: {
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 300,
                              width: "100%",
                              borderTypeFlag: 1,
                              borderRadius: [0, 0, 0, 0],
                              borderWidth: 0,
                              borderStyle: "solid",
                              borderColor: "rgba(0,0,0,0)",
                              borderIsThemeColor: false,
                              tabRow: true
                            },
                            rectIds: [],
                            layout: {
                              rows: [],
                              cols: []
                            }
                          }
                        ],
                        cols: []
                      }
                    }
                  ],
                  cols: []
                }
              }
            ]
          })
        break
      case 8:
        ;(this.id = 1),
          (this.options = {
            bg: [],
            padding: [40, 0, 40, 0],
            opacity: 100,
            height: 400,
            paddingTypeFlag: 2,
            isFullPage: false,
            inDocument: "none",
            isFixed: false,
            isShow: true,
            isShowTabs: true, //横向标签通栏标志
            isShowVerticalTabs: true //竖向标签通栏标志
          }),
          (this.layout = {
            rows: [
              {
                id: 0,
                options: {
                  padding: [0, 0, 0, 0],
                  bg: [],
                  height: 400,
                  width: "100%",
                  borderTypeFlag: 1,
                  borderRadius: [0, 0, 0, 0],
                  borderWidth: 0,
                  borderStyle: "solid",
                  borderColor: "rgba(0,0,0,0)",
                  borderIsThemeColor: false
                },
                rectIds: [],
                layout: {
                  rows: [
                    {
                      id: 0,
                      options: {
                        padding: [0, 0, 0, 0],
                        bg: [],
                        width: "100%",
                        borderTypeFlag: 1,
                        borderRadius: [0, 0, 0, 0],
                        borderWidth: 0,
                        borderStyle: "solid",
                        borderColor: "rgba(0,0,0,0)",
                        borderIsThemeColor: false
                      },
                      rectIds: [],
                      layout: {
                        rows: [],
                        cols: [
                          {
                            id: 0,
                            options: {
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 400,
                              width: "28%",
                              borderTypeFlag: 1,
                              borderRadius: [0, 0, 0, 0],
                              borderWidth: 0,
                              borderStyle: "solid",
                              borderColor: "rgba(0,0,0,0)",
                              borderIsThemeColor: false,
                              tabCol: true //竖向标签列标志 用于判断是否显示添加列
                            },
                            rectIds: [],
                            layout: {
                              rows: [],
                              cols: []
                            }
                          },
                          {
                            id: 1,
                            options: {
                              padding: [0, 0, 0, 0],
                              bg: [],
                              height: 400,
                              width: "72%",
                              borderTypeFlag: 1,
                              borderRadius: [0, 0, 0, 0],
                              borderWidth: 0,
                              borderStyle: "solid",
                              borderColor: "rgba(0,0,0,0)",
                              borderIsThemeColor: false
                            },
                            rectIds: [],
                            layout: {
                              rows: [],
                              cols: [
                                {
                                  id: 0,
                                  options: {
                                    padding: [0, 0, 0, 0],
                                    bg: [],
                                    height: 400,
                                    width: "100%",
                                    borderTypeFlag: 1,
                                    borderRadius: [0, 0, 0, 0],
                                    borderWidth: 0,
                                    borderStyle: "solid",
                                    borderColor: "rgba(0,0,0,0)",
                                    borderIsThemeColor: false,
                                    tabCol: true
                                  },
                                  rectIds: [],
                                  layout: {
                                    rows: [],
                                    cols: []
                                  }
                                },
                                {
                                  id: 1,
                                  options: {
                                    padding: [0, 0, 0, 0],
                                    bg: [],
                                    height: 400,
                                    width: "100%",
                                    borderTypeFlag: 1,
                                    borderRadius: [0, 0, 0, 0],
                                    borderWidth: 0,
                                    borderStyle: "solid",
                                    borderColor: "rgba(0,0,0,0)",
                                    borderIsThemeColor: false,
                                    tabCol: true
                                  },
                                  rectIds: [],
                                  layout: {
                                    rows: [],
                                    cols: []
                                  }
                                },
                                {
                                  id: 2,
                                  options: {
                                    padding: [0, 0, 0, 0],
                                    bg: [],
                                    height: 400,
                                    width: "100%",
                                    borderTypeFlag: 1,
                                    borderRadius: [0, 0, 0, 0],
                                    borderWidth: 0,
                                    borderStyle: "solid",
                                    borderColor: "rgba(0,0,0,0)",
                                    borderIsThemeColor: false,
                                    tabCol: true
                                  },
                                  rectIds: [],
                                  layout: {
                                    rows: [],
                                    cols: []
                                  }
                                }
                              ]
                            }
                          }
                        ]
                      }
                    }
                  ],
                  cols: []
                }
              }
            ]
          })
        break
      case 10:
        ;(this.id = 1),
        (this.options = {
          bg: [],
          padding: [40, 0, 40, 0],
          opacity: 100,
          height: 500,
          paddingTypeFlag: 2,
          isFullPage: false,
          inDocument: "none",
          isFixed: false,
          isShow: true,
          isAccordionLayout: true, //手风琴布局标志
          openIndex: 0,
          defaultWidth: 13,
          activeWidth: 60,
        }),
        (this.layout = {
          rows: [
            {
              id: 0,
              options: {
                padding: [0, 0, 0, 0],
                bg: [
                  {
                    type: "color",
                    label: "颜色",
                    isThemeColor: false,
                    color: "rgba(242,244,247,1)"
                  }
                ],
                height: 500,
                width: "100%",
                borderTypeFlag: 1,
                borderRadius: [0, 0, 0, 0],
                borderWidth: 0,
                borderStyle: "solid",
                borderColor: "rgba(0,0,0,0)",
                borderIsThemeColor: false,
                isAccordionLayoutRow: true, // 手风琴布局第一层标志
                accordionMargin: 10,
              },
              rectIds: [],
              layout: {
                rows: [],
                cols: [
                  {
                    id: 0,
                    options: {
                      padding: [0, 0, 0, 0],
                      height: 400,
                      width: "60%",
                      borderTypeFlag: 1,
                      borderRadius: [0, 0, 0, 0],
                      borderWidth: 0,
                      borderStyle: "solid",
                      borderColor: "rgba(0,0,0,0)",
                      borderIsThemeColor: false,
                      isAccordionLayoutCol: true, // 手风琴布局组件层标志
                      activeHeightType: "%",
                      bg: [
                        {
                          type: "color",
                          label: "颜色",
                          isThemeColor: false,
                          color: "rgba(255,255,255,1)"
                        }
                      ],
                      activeBackground: [
                        {
                          type: "color",
                          label: "颜色",
                          isThemeColor: false,
                          color: "rgba(255,255,255,1)"
                        }
                      ],
                    },
                    rectIds: [],
                    layout: {
                      rows: [],
                      cols: []
                    }
                  },
                  {
                    id: 1,
                    options: {
                      padding: [0, 0, 0, 0],
                      height: 400,
                      width: "13%",
                      borderTypeFlag: 1,
                      borderRadius: [0, 0, 0, 0],
                      borderWidth: 0,
                      borderStyle: "solid",
                      borderColor: "rgba(0,0,0,0)",
                      borderIsThemeColor: false,
                      isAccordionLayoutCol: true,
                      activeHeightType: "%",
                      bg: [
                        {
                          type: "color",
                          label: "颜色",
                          isThemeColor: false,
                          color: "rgba(255,255,255,1)"
                        }
                      ],
                      activeBackground: [
                        {
                          type: "color",
                          label: "颜色",
                          isThemeColor: false,
                          color: "rgba(255,255,255,1)"
                        }
                      ],
                    },
                    rectIds: [],
                    layout: {
                      rows: [],
                      cols: []
                    }
                  },
                  {
                    id: 2,
                    options: {
                      padding: [0, 0, 0, 0],
                      height: 400,
                      width: "13%",
                      borderTypeFlag: 1,
                      borderRadius: [0, 0, 0, 0],
                      borderWidth: 0,
                      borderStyle: "solid",
                      borderColor: "rgba(0,0,0,0)",
                      borderIsThemeColor: false,
                      isAccordionLayoutCol: true,
                      activeHeightType: "%",
                      bg: [
                        {
                          type: "color",
                          label: "颜色",
                          isThemeColor: false,
                          color: "rgba(255,255,255,1)"
                        }
                      ],
                      activeBackground: [
                        {
                          type: "color",
                          label: "颜色",
                          isThemeColor: false,
                          color: "rgba(255,255,255,1)"
                        }
                      ],
                    },
                    rectIds: [],
                    layout: {
                      rows: [],
                      cols: []
                    }
                  },
                  {
                    id: 3,
                    options: {
                      padding: [0, 0, 0, 0],
                      height: 400,
                      width: "13%",
                      borderTypeFlag: 1,
                      borderRadius: [0, 0, 0, 0],
                      borderWidth: 0,
                      borderStyle: "solid",
                      borderColor: "rgba(0,0,0,0)",
                      borderIsThemeColor: false,
                      isAccordionLayoutCol: true,
                      activeHeightType: "%",
                      bg: [
                        {
                          type: "color",
                          label: "颜色",
                          isThemeColor: false,
                          color: "rgba(255,255,255,1)"
                        }
                      ],
                      activeBackground: [
                        {
                          type: "color",
                          label: "颜色",
                          isThemeColor: false,
                          color: "rgba(255,255,255,1)"
                        }
                      ],
                    },
                    rectIds: [],
                    layout: {
                      rows: [],
                      cols: []
                    }
                  }
                ]
              }
            }
          ]
      })
      break
      default:
        ;(this.options = {
          bg: [],
          padding: [40, 0, 40, 0],
          opacity: 100,
          height: 200,
          paddingTypeFlag: 2,
          isFullPage: false,
          inDocument: "none",
          isFixed: false,
          isShow: true
        }),
          (this.id = 1),
          (this.layout = {
            rows: [
              {
                id: 0,
                options: {
                  padding: [0, 0, 0, 0],
                  bg: [],
                  height: 200,
                  width: "100%",
                  borderTypeFlag: 1,
                  borderRadius: [0, 0, 0, 0],
                  borderWidth: 0,
                  borderStyle: "solid",
                  borderColor: "rgba(0,0,0,0)",
                  borderIsThemeColor: false
                },
                rectIds: [],
                layout: {
                  rows: [],
                  cols: []
                }
              }
            ]
          })
    }
    this.objDiff(this, specialOpt)
  }
}

export default {
  page: {
    id: 1,
    name: "测试模板pc",
    height: 1334,
    hasHeader: true,
    headerIsFixed: true,
    pageWidth: 375, //编辑区域宽度
    openComplexFont: false, //开启繁简转换
    themeColor: "#3D82F2",
    editPageThemeColor: "0", //编辑页风格
    showRuler: true,
    enablePullRefresh: false,
    pullText: '',
    releaseText: '',
    globalBgSetting: {
      bgType: "color",
      colorType: "纯色", //纯色，线性渐变，径向渐变
      color: "#fff",
      startColor: "#fff",
      endColor: "#fff",
      colorlinearGradientAngle: 90,
      imgSrc: "",
      clipSize: "cover",
      repeatType: "no-repeat",
      alignType: "center center",
      sizeType: 4,
      opacity: 100
    },
    // children: [
    //   {
    //     container_id: 0,
    //     width: 375,
    //     height: 667,
    //     isActive: false,
    //     children: [],
    //     options: {
    //       background: []
    //     }
    //   },
    //   {
    //     container_id: 1,
    //     width: 375,
    //     height: 667,
    //     isActive: false,
    //     children: []
    //   }
    // ],
    children: [
      new primaryAppStageGenerator({
        container_id: 0,
        options: {
          background: [
            {
              type: "color",
              label: "颜色",
              isThemeColor: false,
              color: "#fff"
            }
          ]
        }
      })
    ],
    appIdList: [],
    global: {
      bayWindowOpen: false
    }
  },
  treeData: [
    {
      id: 0,
      label: "测试模板pc",
      children: [
        {
          id: 0,
          label: "画布0",
          children: []
        },
        {
          id: 1,
          label: "画布1",
          children: []
        }
      ]
    }
  ],
  template_v2_mh: 1,
  version: 0
}

// 默认app端列表页数据
export const appPageListPageData = {
  page: {
    id: 1,
    name: "列表页模版pc",
    height: 1800,
    hasHeader: true,
    headerIsFixed: true,
    pageWidth: 1920, //编辑区域宽度
    openComplexFont: false, //开启繁简转换
    themeColor: "#3D82F2",
    showRuler: true,
    listPageSetting: {
      // 列表页配置项
      showNavMenu: true, // 显示导航
      navMenuDisplayPosition: "left", // 导航显示位置
      showApplicationName: true, // 显示应用名称
      openListPageSwitch: true, // 开启列表页切换
      showSearchComponent: true, // 显示列表页搜索
      showBreadCrumbs: true, // 显示面包屑
      showHeadFoot: true, // 显示头底
    },
    globalBgSetting: {
      bgType: "color",
      colorType: "纯色", //纯色，线性渐变，径向渐变
      color: "#fff",
      startColor: "#fff",
      endColor: "#fff",
      colorlinearGradientAngle: 90,
      imgSrc: "",
      clipSize: "cover",
      repeatType: "no-repeat",
      alignType: "center center",
      sizeType: 4,
      opacity: 100,
      containerAnimateSet: {
        direction: "upDown",
        animateType: "regular",
        animateClass__pageUp: "up",
        animateClass__pageDown: "down",
        nextAnimateClass: "",
        prevAnimateClass: "",
        isAutoPlay: false,
        autoPlayDelay: 3
      }
    },
    children: [
      new primaryStageGenerator({
        container_id: 0,
        options: {
          isFixed: true,
          background: [
            {
              type: "color",
              label: "颜色",
              isThemeColor: false,
              color: "#fff"
            }
          ]
        }
      })
    ],
    appIdList: [],
    setting: {
      type: "template_2_1"
    }
  },
  template_v2_mh: 1,
  version: 0,
  type: "listPage"
}

// 默认app端详情页数据
export const appDetailPageData = {
  page: {
    id: 1,
    name: "详情页模版pc",
    height: 1800,
    hasHeader: true,
    headerIsFixed: true,
    pageWidth: 1920, //编辑区域宽度
    openComplexFont: false, //开启繁简转换
    themeColor: "#3D82F2",
    showRuler: true,
    globalBgSetting: {
      bgType: "color",
      colorType: "纯色", //纯色，线性渐变，径向渐变
      color: "#fff",
      startColor: "#fff",
      endColor: "#fff",
      colorlinearGradientAngle: 90,
      imgSrc: "",
      clipSize: "cover",
      repeatType: "no-repeat",
      alignType: "center center",
      sizeType: 4,
      opacity: 100,
      containerAnimateSet: {
        direction: "upDown",
        animateType: "regular",
        animateClass__pageUp: "up",
        animateClass__pageDown: "down",
        nextAnimateClass: "",
        prevAnimateClass: "",
        isAutoPlay: false,
        autoPlayDelay: 3
      }
    },
    children: [
      new primaryStageGenerator({
        container_id: 0,
        options: {
          isFixed: true,
          background: [
            {
              type: "color",
              label: "颜色",
              isThemeColor: false,
              color: "#fff"
            }
          ]
        }
      })
    ],
    appIdList: [],
    setting: {
      type: "template_2_1"
    }
  },
  template_v2_mh: 1,
  version: 0,
  type: "detailPage"
}
